import {lazy} from 'react';

export const ProfileChatsAsync = lazy(() =>
    import('./ProfileChats')
);
